import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { client, BASE_URL } from '../api/client';
import { getThunkName, createThunkName, updateThunkName, deleteThunkName } from './base';
import { thunkPerformanceAchievementApi } from './performance-achievement';

export const thunkPerformanceResult = 'hasil-capaian';
export const thunkDispositionPerformanceResult = 'hasil-capaian/disposisi';
export const thunkEditModePerformanceResult = 'hasil-capaian/editmode';
export const thunkQuarterResult = 'triwulan';
export const slicePerformanceAchievementName = 'kelola-hasil-capaian';

export const getPerformanceResultList = createAsyncThunk(getThunkName(thunkPerformanceResult), async ({ id, triwulan }, { rejectWithValue }) => {
  try {
    const response = await client.get(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceResult + '/' + thunkQuarterResult + '/' + triwulan, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const createPerformanceResult = createAsyncThunk(createThunkName(thunkPerformanceResult), async ({ id, body }, { rejectWithValue }) => {
  try {
    const response = await client.post(BASE_URL + thunkPerformanceAchievementApi + '/' + id + '/' + thunkPerformanceResult, body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updateEditModePerformanceResult = createAsyncThunk(updateThunkName(thunkEditModePerformanceResult), async ({ idSasaran, id, body }, { rejectWithValue }) => {
  try {
    const response = await client.put(BASE_URL + thunkPerformanceAchievementApi + '/' + idSasaran + '/' + thunkPerformanceResult + '/' + id + '/editmode', body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const updateDispositionPerformanceResult = createAsyncThunk(updateThunkName(thunkDispositionPerformanceResult), async ({ idSasaran, id, body }, { rejectWithValue }) => {
  try {
    const response = await client.put(BASE_URL + thunkPerformanceAchievementApi + '/' + idSasaran + '/' + thunkPerformanceResult + '/' + id + '/disposisi', body, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const deletePerformanceResult = createAsyncThunk(deleteThunkName(thunkPerformanceResult), async ({ idSasaran, id }, { rejectWithValue }) => {
  try {
    const response = await client.delete(BASE_URL + thunkPerformanceAchievementApi + '/' + idSasaran + '/' + thunkPerformanceResult + '/' + id, {
      headers: {
        Authorization: localStorage.getItem('token'),
      },
    });
    return response.data;
  } catch (err) {
    return rejectWithValue(err);
  }
});

export const PerformanceAchievementSlice = createSlice({
  name: slicePerformanceAchievementName,
  initialState: {
    get: {
      data: [],
      status: 'idle',
      message: '',
      error: '',
      pagination: {},
    },
    create: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    updateEditMode: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    updateDisposition: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
    delete: {
      data: {},
      status: 'idle',
      message: '',
      error: '',
    },
  },
  reducers: {},
  extraReducers(builder) {
    builder
    .addCase(getPerformanceResultList.pending, state => {
      state.get.data = [];
      state.get.status = 'loading';
      state.get.message = '';
      state.get.error = '';
      state.get.pagination = {};
    })
    .addCase(getPerformanceResultList.fulfilled, (state, action) => {
      state.get.data = action.payload.data;
      state.get.status = 'succeeded';
      state.get.message = action.payload.message;
      state.get.error = '';
      state.get.pagination = action.payload.meta;
    })
    .addCase(getPerformanceResultList.rejected, (state, action) => {
      state.get.data = [];
      state.get.status = 'failed';
      state.get.message = action.payload.message;
      state.get.error = action.payload.error;
      state.get.pagination = {};
    })
    .addCase(createPerformanceResult.pending, state => {
      state.create.data = {};
      state.create.status = 'loading';
      state.create.message = '';
      state.create.error = '';
    })
    .addCase(createPerformanceResult.fulfilled, (state, action) => {
      state.create.data = action.payload.data;
      state.create.status = 'succeeded';
      state.create.message = action.payload.message;
      state.create.error = '';
    })
    .addCase(createPerformanceResult.rejected, (state, action) => {
      state.create.data = {};
      state.create.status = 'failed';
      state.create.message = action.payload.message;
      state.create.error = action.payload.error;
    })
    .addCase(updateEditModePerformanceResult.pending, state => {
      state.updateEditMode.data = {};
      state.updateEditMode.status = 'loading';
      state.updateEditMode.message = '';
      state.updateEditMode.error = '';
    })
    .addCase(updateEditModePerformanceResult.fulfilled, (state, action) => {
      state.updateEditMode.data = action.payload.data;
      state.updateEditMode.status = 'succeeded';
      state.updateEditMode.message = action.payload.message;
      state.updateEditMode.error = '';
    })
    .addCase(updateEditModePerformanceResult.rejected, (state, action) => {
      state.updateEditMode.data = {};
      state.updateEditMode.status = 'failed';
      state.updateEditMode.message = action.payload.message;
      state.updateEditMode.error = action.payload.error;
    })
    .addCase(updateDispositionPerformanceResult.pending, state => {
      state.updateDisposition.data = {};
      state.updateDisposition.status = 'loading';
      state.updateDisposition.message = '';
      state.updateDisposition.error = '';
    })
    .addCase(updateDispositionPerformanceResult.fulfilled, (state, action) => {
      state.updateDisposition.data = action.payload.data;
      state.updateDisposition.status = 'succeeded';
      state.updateDisposition.message = action.payload.message;
      state.updateDisposition.error = '';
    })
    .addCase(updateDispositionPerformanceResult.rejected, (state, action) => {
      state.updateDisposition.data = {};
      state.updateDisposition.status = 'failed';
      state.updateDisposition.message = action.payload.message;
      state.updateDisposition.error = action.payload.error;
    })
    .addCase(deletePerformanceResult.pending, state => {
      state.delete.data = {};
      state.delete.status = 'loading';
      state.delete.message = '';
      state.delete.error = '';
    })
    .addCase(deletePerformanceResult.fulfilled, (state, action) => {
      state.delete.data = action.payload.data;
      state.delete.status = 'succeeded';
      state.delete.message = action.payload.message;
      state.delete.error = '';
    })
    .addCase(deletePerformanceResult.rejected, (state, action) => {
      state.delete.data = {};
      state.delete.status = 'failed';
      state.delete.message = action.payload.message;
      state.delete.error = action.payload.error;
    })
  },
});

export default PerformanceAchievementSlice.reducer;
